'use client'

import { useViewAffiliateStorefrontPage } from '@src/utils/analytics.util'

export const Analytics = () => {
  useViewAffiliateStorefrontPage()
  return null
}
